import gql from 'graphql-tag'
export default gql`
  mutation updateSearchVariables ($key: String!, $value: String!, $merge: SearchVariables) {
    updateSearchVariables(key: $key, value: $value, merge: $merge) @client
  }
`
